export * from './page-data-table.component'